module.exports = __webpack_public_path__ + "img/cat.6e9288b8.svg";